import * as Yup from "yup";

import { createForm } from "../../../forms";

import type { TypeSafeReactLocalization } from "../../../../composites";

export type RecipientProfileType = {
  name: string;
  nickname?: string;
  type: string;
};

export const translateValidationSchema = ({
  getString,
}: TypeSafeReactLocalization) =>
  Yup.object().shape({
    name: Yup.string()
      .test(
        "not-just-whitespace",
        getString("form-generic-validation-at-least-characters", { count: 1 }),
        (value) => {
          if (!value) return false;
          return value.trim().length > 0;
        },
      )
      .trim()
      .required(getString("form-generic-validation-required"))
      .max(140),
    nickname: Yup.string()
      .test(
        "not-just-whitespace",
        getString("form-generic-validation-at-least-characters", { count: 1 }),
        (value) => {
          if (!value) return true; // Allow undefined/null/empty since it's optional
          return value.trim().length > 0; // Reject whitespace-only strings
        },
      )
      .max(20),
    type: Yup.string().required(getString("form-generic-validation-required")),
  });

export const recipientProfileInitialValues: RecipientProfileType = {
  name: "",
  nickname: "",
  type: "",
};

export const transformRecipientApiFieldsToFormFields = ({
  id,
  name,
  nickname,
  type,
  ach_destination: achDestination,
  fedwire_destination: fedwireDestination,
}: API.Recipient) => ({
  id,
  name,
  nickname,
  type,
  achDestination,
  fedwireDestination,
});

// define form schema and validations
export const RecipientProfileForm = createForm({
  initialValues: recipientProfileInitialValues,
  translateValidationSchema,
});
